import React from 'react';
import { useTranslation, type Language } from '../../translation';
import '../../style.scss';

interface LanguageSelectorProps {
  className?: string;
}

/**
 * Componente para seleccionar el idioma de la aplicación
 */
export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className = '' }) => {
  const { t, language, setLanguage, getAvailableLanguages } = useTranslation();
  
  // Obtener los idiomas disponibles
  const languages = getAvailableLanguages();
  
  // Función para obtener el nombre del idioma
  const getLanguageName = (lang: Language): string => {
    switch (lang) {
      case 'es': return 'Español';
      case 'fr': return 'Français';
      case 'en': return 'English';
      default: return lang;
    }
  };
  
  return (
    <div className={`language-selector ${className}`}>
      <label htmlFor="language-select">{t('language')}: </label>
      <select 
        id="language-select"
        value={language}
        onChange={(e) => { setLanguage(e.target.value as Language); window.location.reload(); }}
        className="language-select"
      >
        {languages.map((lang) => (
          <option key={lang} value={lang}>
            {getLanguageName(lang)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;